import request from "@/utils/request";

export function queryPrices(data){
  return request({
    url:'/osp/priceParam/queryPrices',
    method:'post',
    data: data
  })
}
